module.exports = __webpack_public_path__ + "img/bluetooth.5689b83e.png";